import {type ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, type ButtonProps} from '../button';
import {useCopyToClipboard} from '../hooks/use-copy-to-clipboard';

export type CopyLinkButtonProps = {
  link: string | undefined;
  labelText: string;
  copiedExclamationText?: string;
  className?: string;
  disabled?: boolean;
  leftAddon?: ReactNode;
  onCopiedLink?: () => void;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
};

export function CopyLinkButton({
  className,
  link,
  disabled,
  labelText,
  copiedExclamationText,
  onCopiedLink,
  leftAddon,
  variant = 'outline',
  size = 'sm',
}: CopyLinkButtonProps) {
  const {t} = useTranslation();
  const {isCopied, copy} = useCopyToClipboard({value: link, onCopiedLink});

  return (
    <Button
      className={className}
      onClick={copy}
      disabled={!link || disabled}
      variant={variant}
      size={size}
    >
      {leftAddon}
      {isCopied
        ? copiedExclamationText || t('copied_exclamation') || labelText
        : labelText}
    </Button>
  );
}
